// Module
var code = "<template> <compose view-model.bind=\"getViewModel(definition)\" model.bind=\"getModel(definition, container, disabled)\"></compose> </template> ";
// Exports
module.exports = code;